<template>
  <div
    v-bind:style="styles"
    class="spinner spinner--dragster-neon"
    :class="{'spinner--dragster-neon-preview': preview}"
    role="status"
    aria-label="Chargement en cours, animation d'un dragster"
  >
    <span class="race-track" aria-hidden="true"></span>
    <span class="race-track race-track--glow" aria-hidden="true"></span>

    <div class="dragster-runner" aria-hidden="true">
      <div class="dragster-stunt">
        <div class="dragster-car">
          <span class="boost-lines">
            <i class="boost-line boost-line--one"></i>
            <i class="boost-line boost-line--two"></i>
            <i class="boost-line boost-line--three"></i>
          </span>

          <span class="skid-mark"></span>
          <span class="dragster-glow"></span>

          <span class="drift-smoke">
            <i class="smoke-puff smoke-puff--one"></i>
            <i class="smoke-puff smoke-puff--two"></i>
            <i class="smoke-puff smoke-puff--three"></i>
            <i class="smoke-puff smoke-puff--four"></i>
          </span>

          <span class="drift-sparks">
            <i></i>
            <i></i>
            <i></i>
          </span>

          <img class="dragster-vehicle" src="../../assets/img/dragster-neon.png" alt=""/>

          <span class="wheel wheel--rear">
            <i class="wheel-spokes"></i>
            <i class="wheel-hub"></i>
          </span>
          <span class="wheel wheel--front">
            <i class="wheel-spokes"></i>
            <i class="wheel-hub"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: '72px'
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styles () {
      var requestedHeight = parseInt(this.size)
      var vehicleHeight = this.preview
        ? Math.max(requestedHeight || 52, 52)
        : Math.max(requestedHeight || 88, 88)
      var stageHeight = this.preview
        ? Math.max(vehicleHeight + 24, 82)
        : Math.max(Math.round(vehicleHeight * 1.65), 148)

      return {
        '--dragster-delay': '-.28s',
        '--dragster-duration': (this.preview ? 4.8 : 4.6) + 's',
        '--dragster-height': vehicleHeight + 'px',
        '--dragster-width': Math.round(vehicleHeight * 2.42) + 'px',
        '--road-level': Math.round(vehicleHeight * .17) + 'px',
        height: stageHeight + 'px',
        width: this.preview ? '240px' : '100vw'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner--dragster-neon {
  isolation: isolate;
  max-width: 100%;
  overflow: hidden;
  pointer-events: none;
  position: relative;
  transform: translateZ(0);
}

.spinner--dragster-neon:not(.spinner--dragster-neon-preview) {
  left: 0;
  max-width: none;
  position: fixed;
  top: 42%;
  width: 100vw !important;
  z-index: 1050;
}

.race-track {
  background: linear-gradient(90deg, transparent, rgba(54, 67, 82, .18) 12%, rgba(54, 67, 82, .38) 50%, rgba(54, 67, 82, .18) 88%, transparent);
  bottom: var(--road-level);
  height: 2px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 0;
}

.race-track::after {
  background: repeating-linear-gradient(90deg, rgba(0, 217, 255, .45) 0 22px, transparent 22px 52px);
  content: '';
  height: 1px;
  left: 0;
  opacity: .45;
  position: absolute;
  top: 5px;
  width: 100%;
}

.race-track--glow {
  background: linear-gradient(90deg, transparent 8%, rgba(0, 217, 255, .2) 42%, rgba(255, 58, 196, .2) 58%, transparent 92%);
  filter: blur(7px);
  height: 9px;
  opacity: .7;
}

.dragster-runner {
  animation: dragster-traverse var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  bottom: 0;
  height: var(--dragster-height);
  left: 0;
  position: absolute;
  width: var(--dragster-width);
  will-change: left, opacity, transform;
  z-index: 2;
}

.dragster-stunt,
.dragster-car {
  height: 100%;
  position: relative;
  width: 100%;
}

.dragster-stunt {
  animation: dragster-stunts var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  transform-origin: 20.2% 68%;
  will-change: transform;
}

.dragster-car {
  animation: dragster-vibration .12s steps(2, end) infinite;
  transform-origin: 20.2% 68%;
}

.dragster-vehicle {
  display: block;
  height: 100%;
  left: 0;
  object-fit: contain;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 3;
}

.dragster-glow {
  animation: dragster-underglow .42s ease-in-out infinite alternate;
  background: linear-gradient(90deg, rgba(255, 90, 0, .1), rgba(0, 217, 255, .85), rgba(255, 48, 195, .15));
  border-radius: 50%;
  bottom: 9%;
  filter: blur(7px);
  height: 13%;
  left: 22%;
  position: absolute;
  width: 67%;
  z-index: 2;
}

.boost-lines {
  animation: boost-window var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  height: 72%;
  opacity: 0;
  position: absolute;
  right: 72%;
  top: 18%;
  width: 82%;
  z-index: 1;
}

.boost-line {
  animation: boost-line .38s linear infinite;
  background: linear-gradient(90deg, transparent, rgba(0, 217, 255, .12), #00d9ff);
  border-radius: 999px;
  height: 2px;
  left: 0;
  opacity: .9;
  position: absolute;
  transform-origin: right center;
  width: 100%;
}

.boost-line--one {
  animation-delay: 0s;
  top: 18%;
  width: 72%;
}

.boost-line--two {
  animation-delay: -.13s;
  top: 48%;
}

.boost-line--three {
  animation-delay: -.26s;
  top: 77%;
  width: 58%;
}

.wheel {
  animation: wheel-spin .17s linear infinite;
  border-radius: 50%;
  filter: drop-shadow(0 0 2px rgba(0, 217, 255, .8));
  position: absolute;
  z-index: 5;
}

.wheel--rear {
  height: 36.3%;
  left: 12.8%;
  top: 47.5%;
  width: 15%;
}

.wheel--front {
  animation-duration: .11s;
  height: 20.8%;
  left: 82.7%;
  top: 61%;
  width: 8.6%;
}

.wheel-spokes {
  background: repeating-conic-gradient(from 8deg, rgba(0, 217, 255, .95) 0 7deg, transparent 7deg 28deg);
  border: 1px solid rgba(255, 105, 24, .75);
  border-radius: 50%;
  bottom: 17%;
  box-shadow: inset 0 0 4px rgba(255, 48, 195, .95), 0 0 5px rgba(0, 217, 255, .7);
  left: 17%;
  position: absolute;
  right: 17%;
  top: 17%;
}

.wheel-spokes::after {
  background: repeating-conic-gradient(from 0deg, #ff6326 0 5deg, transparent 5deg 22deg);
  border-radius: 50%;
  bottom: 18%;
  content: '';
  left: 18%;
  position: absolute;
  right: 18%;
  top: 18%;
}

.wheel-hub {
  background: #09111b;
  border: 1px solid #ffd6a7;
  border-radius: 50%;
  box-shadow: 0 0 4px #ff5a00;
  height: 22%;
  left: 39%;
  position: absolute;
  top: 39%;
  width: 22%;
}

.drift-smoke {
  animation: drift-window var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  height: 72%;
  left: -13%;
  opacity: 0;
  position: absolute;
  top: 29%;
  width: 46%;
  z-index: 6;
}

.smoke-puff {
  animation: smoke-puff .82s ease-out infinite;
  background: radial-gradient(circle, rgba(223, 240, 248, .92) 0, rgba(102, 128, 145, .72) 42%, rgba(30, 47, 61, 0) 74%);
  border-radius: 50%;
  bottom: 8%;
  filter: blur(1.4px);
  height: 42%;
  position: absolute;
  right: 0;
  width: 42%;
}

.smoke-puff--two {
  animation-delay: -.2s;
}

.smoke-puff--three {
  animation-delay: -.4s;
}

.smoke-puff--four {
  animation-delay: -.6s;
}

.skid-mark {
  animation: skid-window var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  background: linear-gradient(90deg, transparent, rgba(24, 30, 37, .62));
  border-radius: 50%;
  bottom: 15%;
  height: 3px;
  opacity: 0;
  position: absolute;
  right: 78%;
  transform-origin: right center;
  width: 78%;
  z-index: 1;
}

.drift-sparks {
  animation: drift-window var(--dragster-duration) linear infinite;
  animation-delay: var(--dragster-delay);
  bottom: 15%;
  height: 28%;
  left: 10%;
  opacity: 0;
  position: absolute;
  width: 26%;
  z-index: 7;
}

.drift-sparks i {
  animation: spark-fly .46s linear infinite;
  background: #ffd36a;
  border-radius: 50%;
  bottom: 0;
  box-shadow: 0 0 4px #ff5a00;
  height: 3px;
  position: absolute;
  right: 0;
  width: 3px;
}

.drift-sparks i:nth-child(2) {
  animation-delay: -.15s;
}

.drift-sparks i:nth-child(3) {
  animation-delay: -.3s;
}

@keyframes dragster-traverse {
  0%, 5% {
    left: 0;
    opacity: 0;
    transform: translate3d(-135%, 0, 0);
  }
  8% {
    opacity: 1;
  }
  25% {
    left: 30%;
    transform: translate3d(-45%, 0, 0);
  }
  41% {
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }
  49% {
    left: 53%;
    transform: translate3d(-50%, 0, 0);
  }
  57% {
    left: 47%;
    transform: translate3d(-50%, 0, 0);
  }
  66% {
    left: 52%;
    transform: translate3d(-50%, 0, 0);
  }
  72% {
    left: 62%;
    transform: translate3d(-50%, 0, 0);
  }
  96% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
    transform: translate3d(18%, 0, 0);
  }
}

@keyframes dragster-stunts {
  0%, 13%, 43%, 46%, 70%, 100% {
    transform: translate3d(0, 0, 0) rotate(0) skewX(0) scaleX(1);
  }
  19% {
    transform: translate3d(0, -2%, 0) rotate(-8deg);
  }
  27% {
    transform: translate3d(0, -4%, 0) rotate(-14deg);
  }
  35% {
    transform: translate3d(0, -2%, 0) rotate(-11deg);
  }
  40% {
    transform: translate3d(0, 1%, 0) rotate(3deg);
  }
  50% {
    transform: translate3d(-3%, -2%, 0) rotate(10deg) skewX(-10deg) scaleX(.92);
  }
  56% {
    transform: translate3d(-8%, 0, 0) rotate(-9deg) skewX(10deg) scaleX(.89);
  }
  62% {
    transform: translate3d(-4%, -1%, 0) rotate(6deg) skewX(-7deg) scaleX(.94);
  }
  67% {
    transform: translate3d(0, 0, 0) rotate(-2deg) skewX(2deg) scaleX(.99);
  }
}

@keyframes dragster-vibration {
  from {
    transform: translate3d(0, -.6%, 0) rotate(-.12deg);
  }
  to {
    transform: translate3d(0, .6%, 0) rotate(.12deg);
  }
}

@keyframes wheel-spin {
  to {
    transform: rotate(1turn);
  }
}

@keyframes boost-line {
  from {
    opacity: 0;
    transform: translate3d(85%, 0, 0) scaleX(.12);
  }
  24% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-18%, 0, 0) scaleX(1);
  }
}

@keyframes boost-window {
  0%, 4%, 44%, 68%, 100% {
    opacity: 0;
  }
  8%, 36%, 74%, 96% {
    opacity: 1;
  }
}

@keyframes drift-window {
  0%, 46%, 69%, 100% {
    opacity: 0;
  }
  50%, 65% {
    opacity: 1;
  }
}

@keyframes smoke-puff {
  from {
    opacity: .88;
    transform: translate3d(0, 0, 0) scale(.35);
  }
  to {
    opacity: 0;
    transform: translate3d(-150%, -72%, 0) scale(1.45);
  }
}

@keyframes skid-window {
  0%, 47%, 69%, 100% {
    opacity: 0;
    transform: scaleX(.08) rotate(-1deg);
  }
  53% {
    opacity: .78;
  }
  66% {
    opacity: .5;
    transform: scaleX(1) rotate(1deg);
  }
}

@keyframes spark-fly {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
  to {
    opacity: 0;
    transform: translate3d(-700%, -260%, 0) scale(.4);
  }
}

@keyframes dragster-underglow {
  from {
    opacity: .35;
    transform: scaleX(.78);
  }
  to {
    opacity: .9;
    transform: scaleX(1.05);
  }
}

@media (max-width: 767px) {
  .spinner--dragster-neon:not(.spinner--dragster-neon-preview) {
    top: 45%;
  }

  .drift-sparks {
    display: none;
  }
}
</style>
